<template>
  <FormContainer>
    <template #title>Adresse employeur</template>
    <template #content>
      <div class="form__bloc">
        <WrapperInput
          id="field_4a"
          :model-value="model?.employeur?.etablissement?.adresse?.voie"
          :label="LABEL_NUMERO_VOIE"
          class="col-10 col-md-18 col-sm-36"
          disabled
        />
        <WrapperInput
          id="field_4b"
          :model-value="model?.employeur?.etablissement?.adresse?.complement"
          label="Complément d'adresse"
          class="col-10 col-md-18 col-sm-36"
          disabled
        />
        <WrapperInput
          id="field_4c"
          :model-value="model?.employeur?.etablissement?.adresse?.codePostal"
          label="Code postal"
          class="col-6 col-md-8 col-sm-36"
          disabled
        />
        <WrapperInput
          id="field_4d"
          :model-value="model?.employeur?.etablissement?.adresse?.commune"
          label="Commune"
          class="col-10 col-md-28 col-sm-36"
          disabled
        />
      </div>
      <div v-if ="estDossier" class="form__bloc">
        <WrapperInputTelephone
          id="field_5"
          v-model="telephoneModel"
          label="Téléphone"
          class="col-10 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_TEL"
          :required="meta.employeur?.contact?.telephone?.$status === PropertyStatus.Required"
          :alertLabel="meta.employeur?.contact?.telephone?.$messageErreurDirty!"
          deletable
          :maxlength="10"
          :readonly
          :disabled="meta.employeur?.contact?.telephone?.$status === PropertyStatus.NotPresent"
        />
        <WrapperInput
          id="field_6"
          v-model="emailModel"
          label="Email"
          class="col-10 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_EMAIL"
          hint="200 caractères maximum"
          :required="meta.employeur?.contact?.email?.$status === PropertyStatus.Required"
          :alertLabel="meta.employeur?.contact?.email?.$messageErreurDirty!"
          deletable
          :maxlength="200"
          :readonly
          :help="emailHelp"
          :disabled="meta.employeur?.contact?.email?.$status === PropertyStatus.NotPresent"
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { TypesContextesAutorisesEnum } from '@/features/auth/context-app'
import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
import {
  DEMANDE_STORE,
  FormContainer,
  LABEL_NUMERO_VOIE,
  PLACEHOLDER_EMAIL,
  PLACEHOLDER_TEL,
} from '@/features/interface/demande/shared'
import { storeToRefs } from 'pinia'
import { computed, inject } from 'vue'

  const store = inject(DEMANDE_STORE)!.getStore('MODEL_CXPI')
  const { setupFieldWithKey } = store
  const { meta, model, readonly, typeContextCourant , estDossier} = storeToRefs(store)

  const telephoneModel = setupFieldWithKey<string>('employeur.contact.telephone', true)
  const emailModel = setupFieldWithKey<string>('employeur.contact.email', true)
  const emailHelp = computed(() => {
    return typeContextCourant.value === TypesContextesAutorisesEnum.Adherent
      ? undefined
      : 'Renseigner ici l’Email de l’employeur ou à défaut l’Email de votre contact entreprise'
  })
</script>
